import { render, staticRenderFns } from "./PageContentImageSkeleton.vue?vue&type=template&id=389a2450"
import script from "./PageContentImageSkeleton.vue?vue&type=script&lang=js"
export * from "./PageContentImageSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports